var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsnewDependencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-whatsnew-dependencies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.67,
    width: 26.67,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.67,
    y: 8.33,
    width: 11.67,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.67,
    y: 8.33,
    width: 11.67,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.67,
    y: 15,
    width: 11.67,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.67,
    y: 15,
    width: 11.67,
    height: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,22.92v4.17H1.25V22.92H12.08m1.25-1.25H0v6.67H13.33V21.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.75,22.92v4.17H17.92V22.92H28.75M30,21.67H16.67v6.67H30V21.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsnewDependencies);
export default __webpack_public_path__ + "static/media/icon-whatsnew-dependencies.bdd7ad471ec9126cdcf06d1643513730.svg";
export { ForwardRef as ReactComponent };